module.exports = __webpack_public_path__ + "static/media/46.12078953.jpg";